import React from 'react';

const ToolTipDropDown = ({ content }) => {
  return (
    <div className="dropdown-menu" role="menu">
      <div className="dropdown-content">
        <div className="dropdown-item">
          <p>
            <em>{content}</em>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ToolTipDropDown;
